import { FormatInterface } from './FormatInterface';
import { NumberFormatter } from './NumberFormatter';
import { Format } from './Format';

export class PercentageFormatter extends NumberFormatter {
  constructor(format: FormatInterface, decimal: boolean = false) {
    format = Format.copy(format);
    format.numbers.isDecimal = decimal;

    super(format, '%');
  }

  public render(value: number): string {
    return super.render(value);
  }
}
